import utilities from '@/utils/utilities.js';

const uaParser = require('ua-parser-js');

export async function getDeviceInformation() {
  var parser = uaParser();
  var ip = await utilities.getPublicIP();
  return {
    browser: `${parser.browser.name ?? ''}${
      parser.browser.version === undefined ? '' : ` (${parser.browser.version})`
    }`,
    device: `${parser.device.vendor ?? ''}${
      parser.device.model === undefined ? '' : ` - ${parser.device.model}`
    }${parser.device.type === undefined ? '' : ` - ${parser.device.type}`}`,
    engine: `${parser.engine.name ?? ''}${
      parser.engine.version === undefined ? '' : ` (${parser.engine.version})`
    }`,
    os: `${parser.os.name ?? ''}${
      parser.os.version === undefined ? '' : ` (${parser.os.version})`
    }`,
    ip: ip,
  };
}
